<template>
  <div
    class="
      border-2
      p-3
      flex flex-col
      hover:border-STorange
      cursor-pointer
      shadow-md
    "
    @click="openLink"
  >
    <p
      class="
        uppercase
        font-OswaldFont
        sm:text-xl
        text-lg text-blue-900
        my-auto
        truncate
      "
    >
      {{ header }}
    </p>

    <div class="flex mt-2">
      <img class="h-12 w-12 rounded-full" :src="authorImage" :alt="author" />
      <p class="my-auto ml-2 uppercase text-sm">{{ author }}</p>
    </div>
  </div>
</template>

<script>
import { generateFullPath } from "../../../utils/fileHelpers";

export default {
  name: "Article",

  props: {
    header: String,
    identifier: String,
    previewMode: Boolean,
    author: String,
  },

  computed: {
    authorImage() {
      return generateFullPath("/images/shottracker_author.png");
    },
  },

  methods: {
    openLink() {
      if (!this.previewMode) {
        this.$router.push({
          name: "ArticlesPage",
          params: { id: this.identifier },
        });
      }
    },
  },
};
</script>

